import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { formatDateTime, mergeParams } from "../../../helpers/helpers";
import peij from "../../../services/peij";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const [tokens, setTokens] = useState([]);
  const [filtros, setFiltros] = useState(
    mergeParams({ usuarioNome: "", validos: true }, location)
  );
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    peij
      .post("assinaturas/listarTokensPagamento", filtrosEnviar)
      .then((res) => {
        res.forEach((t) => (t.validade = formatDateTime(t.validade, "D/M/Y")));
        setTokens(res);
        setCarregando(false);
      })
      .catch((err) => {
        console.log("err", err);

        notification("error", "Não foi possível listar os tokens");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      usuarioNome: {
        label: "Nome do usuário",
        type: "text",
        space: 6,
        value: filtros.usuarioNome,
      },
      validos: {
        label: "Válidos",
        type: "check",
        space: 6,
        value: filtros.validos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Tokens de pagamento",
    onLineClick: (item) =>
      history.push(`/app/token-pagamento-ij/${item.codigo}`),
    // newItemAction: () => history.push("/app/pai/0"),
    columns: [
      {
        name: "usuarioNome",
        label: "Nome do usuário",
      },
      {
        name: "valor",
        label: "Valor",
      },
      {
        name: "maxParcelas",
        label: "Max. Parcelas",
      },
      {
        name: "duracaoAssinatura",
        label: "Duração da assinatura (meses)",
      },
      {
        name: "validade",
        label: "Validade",
      },
    ],
    array: tokens,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
